import VueRouter from 'vue-router';
import guard from './guard';
import routes from '../views';

const mode = 'history';

/**
 * @description Роутер.
 * @param {function} onAfterEach Обработать успешный переход.
 * @constructor
 * @augments VueRouter
 */
export default function Router(onAfterEach) {
  VueRouter.call(this, { mode, routes });
  this.beforeEach(guard);
  this.afterEach(onAfterEach);
}

Router.prototype = Object.create(VueRouter.prototype);
